











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {RastreamentoHistorico} from '@/model/resource/RastreamentoHistorico'
import {RastreamentoHistoricoCollection} from '@/model/collection/RastreamentoHistoricoCollection'
import {ListRastreamentoHistoricoSchema} from '@/schema/resource/RastreamentoHistorico/ListRastreamentoHistoricoSchema'
import {CsvRastreamentoHistoricoSchema} from '@/schema/resource/RastreamentoHistorico/CsvRastreamentoHistoricoSchema'

@Component
export default class ListRastreamentoHistoricoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListRastreamentoHistoricoSchema()
  collection = new RastreamentoHistoricoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: RastreamentoHistorico) {
    Helper.pushByName('editRastreamentoHistorico', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new RastreamentoHistoricoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvRastreamentoHistorico()
    new CsvRastreamentoHistoricoSchema().downloadCsv(csv.all())
  }
}
